import { Badge, Button } from '../ui'

export default function EntraSetupStep({ step, onNext }) {
  const complete = step?.status === 'complete'

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between gap-3">
        <div>
          <h2 className="text-lg font-medium text-[var(--app-text)]">Microsoft Entra ID is connected</h2>
          <p className="mt-1 text-sm text-[var(--app-text-muted)]">
            Your organization completed this connection before signing in to Operations.
          </p>
        </div>
        {complete && <Badge color="success">Complete</Badge>}
      </div>

      <div className="rounded-[var(--app-radius)] border border-[var(--app-border)] bg-[var(--app-surface-2)] p-3">
        <div className="text-xs text-[var(--app-text-muted)]">Identity connection</div>
        <div className="mt-1 font-medium text-[var(--app-text)]">
          Microsoft Entra ID sign-in is ready
        </div>
      </div>

      <div className="flex justify-end">
        <Button color="primary" disabled={!complete} onClick={onNext}>Next</Button>
      </div>
    </div>
  )
}
